import {
  LogLevel,
  LoggerConfig
} from '@/logger';
import {LogsInitConfiguration} from "@datadog/browser-logs";
import packageJson from '../../../package.json';
import {RumInitConfiguration} from "@datadog/browser-rum";

const consoleEnabledEnvironments = [
  'devlocal',
  'development',
]

// Factory function for creating config based on environment
export function createLoggerConfig(environment: string): LoggerConfig {
  const baseConfig: LoggerConfig = {
    environment,
    minLogLevel: environment === 'production' ? LogLevel.INFO : LogLevel.DEBUG,
    enableConsole: consoleEnabledEnvironments.includes(environment),
  };

  const envShortName = import.meta.env.VITE_ENV_SHORT_NAME;

  // Add remote logging and RUM for non-local environments
  if (environment !== 'devlocal') {
    baseConfig.remoteLogging = {
      enabled: true,
      provider: 'datadog',
      // https://docs.datadoghq.com/logs/log_collection/javascript/#configuration
      config: {
        version: packageJson.version,
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN || '',
        site: "datadoghq.eu",
        service: "content-ui",
        env: envShortName || environment,
        sessionSampleRate: environment === 'production' ? 10 : 100,
        // TODO: ensure we are obtaining tracking consent legally
        // https://docs.datadoghq.com/logs/log_collection/javascript/#user-tracking-consent
        trackingConsent: "granted",
      } as LogsInitConfiguration
    };
    baseConfig.realUserMonitoring = {
      enabled: true,
      provider: 'datadog',
      // https://docs.datadoghq.com/real_user_monitoring/browser/setup/client/?tab=rum#initialization-parameters
      config: {
        applicationId: 'cd44d24c-22e2-4aca-b17a-023a1d8fa421',
        clientToken: 'pubeed76982ff23c258b61d432c5b656783',
        site: 'datadoghq.eu',
        service: "content-ui",
        env: envShortName || environment,
        version: packageJson.version,
        trackResources: true,
        trackLongTasks: true,
        // https://docs.datadoghq.com/real_user_monitoring/guide/sampling-browser-plans/
        sessionSampleRate: environment === 'production' ? 10 : 100,
        sessionReplaySampleRate: environment === 'production' ? 10 : 100,
        // https://docs.datadoghq.com/real_user_monitoring/browser/tracking_user_actions/
        trackUserInteractions: true,
        // https://docs.datadoghq.com/data_security/real_user_monitoring/#mask-action-names
        enablePrivacyForActionName: true,
        // https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options/#configuration
        defaultPrivacyLevel: "mask-user-input",
        // TODO: ensure we are obtaining tracking consent legally
        // https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm#user-tracking-consent
        trackingConsent: "granted",
      } as RumInitConfiguration
    }
  }

  return baseConfig;
}
